module.exports = __webpack_public_path__ + "img/Recurso 16.405e59a8.png";